import { EnterpriseCartEvents, trackKeyGrowthEvent } from '@mc/track-event'

export interface trackPropsType {
  action: string
  page_source: string
  location: string
}

export const trackCTAClicked = (trackProps: trackPropsType) => {
  trackKeyGrowthEvent(EnterpriseCartEvents.EVENTS.CONTACT_SALES, {
    ...trackProps,
  })
}
